export enum Permission {
  StoreConfiguration = 'store_configuration_editor.full_scope',
}
